import Utils from 'services/utils';

export default class LabelsController {
    /** @ngInject */
    constructor(LabelsApi, Loader, DialogService, ToastService, $q, $state) {
        this.LabelsApi = LabelsApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.toastService = ToastService;
        this.$q = $q;
        this.$state = $state;
    }

    get currentLabelId() {
        return this.$state.params.labelId;
    }

    $onInit() {
        this.query = '';
        this.labelsLoaded = false;
        this.isCreateBtn = true;

        this.fetch();
    }

    showCreateForm() {
        this.isCreateBtn = false;
        this.isCreateForm = true;
    }

    showCreateBtn() {
        this.isCreateBtn = true;
        this.isCreateForm = false;
        this.name = null;
    }

    submit() {
        this.processing = true;

        this.LabelsApi.create(this.name)
            .then((label) => {
                this.labels.unshift(label);

                this.searchIndex = Utils.buildSearchIndex(this.labels);

                this.name = null;
                this.addLabelForm.$setPristine();
                this.addLabelForm.$setUntouched();

                this.$state.go('main.folders-and-labels.labels.label', {
                    labelId: label.id
                });

                this.toastService.showSimpleTranslated('label_was_created');
            }, () => {
                this.toastService.showSimpleTranslated('label_wasnt_created');
            })
            .finally(() => {
                this.processing = false;
            });
    }

    onSearch({ query }) {
        return Utils.searchInIndex(this.searchIndex, query);
    }

    onLabelFound({ item }) {
        if (item) {
            this.$state.go('main.folders-and-labels.labels.label', {
                labelId: item.id
            });
        }
    }

    fetch() {
        this.Loader.show();

        this.LabelsApi.fetch().then((data) => {
            this.labels = data.labels || [];
            this.searchIndex = Utils.buildSearchIndex(this.labels);
            this.Loader.hide();
        })
        .finally(() => {
            this.labelsLoaded = true;
        });
    }

    cancelEdit() {
        this.$state.go('main.folders-and-labels.labels');
    }

    deleteLabel({ label }) {
        this.LabelsApi
            .remove(label.id)
            .then(() => {
                this.labels.every((item, index) => {
                    if (item.id === label.id) {
                        this.labels.splice(index, 1);
                        return false;
                    }
                    return true;
                });

                this.searchIndex = Utils.buildSearchIndex(this.labels);

                this.toastService.showSimpleTranslated('label_was_removed');
            }, () => {
                this.toastService.showSimpleTranslated('label_wasnt_removed');
            });
        this.cancelEdit();
    }

    saveLabel({ label }) {
        this.LabelsApi
            .update(label.id, label.name)
            .then(() => {
                const labelRef = this.labels.find(item => item.id === label.id);
                Object.assign(labelRef, label);

                this.searchIndex = Utils.buildSearchIndex(this.labels);

                this.toastService.showSimpleTranslated('label_was_updated');
            }, () => {
                this.toastService.showSimpleTranslated('label_wasnt_updated');
            });
    }

    validateLabel({ label }) {
        return {
            unique: this.isLabelUnique(label)
        };
    }

    isLabelUnique(label) {
        for (let i = 0; i < this.labels.length; ++i) {
            if (this.labels[i].name === label.name
                && this.labels[i].id !== label.id) {
                return false;
            }
        }

        return true;
    }

    validateName(name) {
        let isUnique = true;

        for (let i = 0; i < this.labels.length; i++) {
            if (this.labels[i].name === name) {
                isUnique = false;
                break;
            }
        }

        this.addLabelForm.name.$setValidity('unique', isUnique);
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/labels.controller.js